module.exports = __webpack_public_path__ + "img/icon-letter-q.9a9b73e1.svg";